<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/jala-cycle";

export default {
  extends: ModelCreate,
  page: {
    title: "Create JALA Cycles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_cycles.singular')) }},
    resourceRoute: {default: 'jala_cycles'},
    modelVariable: {default: 'jala_cycle'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_cycles.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_cycles.plural')),
          href: "/jala_cycles",
        },
        {
          text: this.$t("Create New"),
          href: "/jala_cycles/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/jala/cycles', value);
    }
  }
}
</script>
